export default "__VITE_ASSET__CCkonJBv__"